import { z } from 'zod';

export const OptionWithOptionalValue = z.object({
  label: z.string(),
  value: z.string().optional(),
});
export type TOptionWithOptionalValue = z.infer<typeof OptionWithOptionalValue>;

export const CommonOption = z.object({
  label: z.string(),
  value: z.string(),
});
export type TCommonOption = z.infer<typeof CommonOption>;
